import React from "react";
import "./Aboutme.css";

const AboutMe = () => {
  return (
    <section className="about-me-section">
      <div className="about-me-content">
        <h1>About Me</h1>
        <h2>Hi There!</h2>
        <p>
             I'm Ashish Gautam, a Computer Engineer with a B.Tech degree and a Master's in Technology Management with Cyber Security.
           I have a passion for web development, creating visually appealing, responsive, and user-friendly websites that combine
            creativity with functionality. My academic background has equipped me with technical expertise and knowledge of 
            technology management and cybersecurity, allowing me to approach projects with a broader understanding of technology,
             security, and innovation. I enjoy crafting engaging digital experiences while continuously exploring the latest web
              technologies and development trends.
        </p>
        <p className="connect-text">Want to know more about me !</p>
        <div className="connect-buttons">
        <a href="https://www.linkedin.com/in/ashishgautam7/" className="connect-button" target="_blank" rel="noopener noreferrer">
  Linkedin
</a>
          <a href="https://github.com/Ashishgtm" className="connect-button" target="_blank" rel="noopener noreferrer">
            Github
          </a>
          <a href="/Professional Resume CV Aashish Gautam.pdf" className="connect-button" download>
  Download CV
</a>

        </div>
      </div>
    </section>
  );
};

export default AboutMe;
